module.exports = __webpack_public_path__ + "media/assets/community/email-logo-a257684f28cdf9c9a04b7c9ba108a5b8d9ea360af1b640ccad02251debd33995.png";